'use client';

import { useInView } from 'motion/react';
import { useRef } from 'react';

import { HeroText } from '@/components/hero-text';

const content = [
    'not',
    <span key="space1">&nbsp;</span>,
    'just',
    <br key="br" />,
    'the end result',
];

export const Subheading = () => {
    const belowRef = useRef<HTMLDivElement>(null);
    const isInView = useInView(belowRef, { amount: 0.2, once: true });

    return (
        <div ref={belowRef}>
            <HeroText
                content={content}
                delayStartAnimation={0}
                shouldStartAnimation={isInView}
                className={`
                  typography-h2-m absolute top-[2vh] z-0

                  md:typography-h3 md:leading-[120%]
                `}
                tagName="h2"
            />
        </div>
    );
};
